<template>
  <v-dialog v-model="isWelcomeDialogVisible" persistent max-width="550px" :fullscreen="xs" style="min-height: 300px">
    <v-card v-if="isReady && welcomeItemToDisplay">
      <v-card-title v-if="welcomeItemToDisplay.id !== -1" class="justify-end py-3">
        <v-btn icon @click="close">
          <v-icon dense>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="d-flex align-start justify-center" style="width: 100%">
        <img v-if="welcomeItemImg" :src="moduleFileUrl('welcome', welcomeItemImg.filename, welcomeItemImg.checksum)" style="width: 100%; object-fit: contain" />
      </div>
      <v-card-text :style="{ minHeight: welcomeItemToDisplay.mg ? '0px' : '100px' }">
        <!-- Welcome text in case of no user welcomeItem -->
        <div style="padding-top: 20px" class="d-flex justify-center align-center text-h5">{{ greeting }}</div>

        <!-- welcome text -->
        <div v-if="welcomeItemToDisplay.id > 0" class="welcome-text new-class" style="width: 100%; text-align: center; white-space: pre-line">
          {{ welcomeItemToDisplay.text }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-center" :class="{ alignEnd: welcomeItemToDisplay.id !== -1 }">
        <!-- Close and do not show again feature-->
        <v-btn
          v-if="welcomeItemToDisplay.id !== -1 && isWelcomeDoNotShowAgainEnabled"
          :color="theme.elements.btnActive"
          @click="
            dontShowAgain = true;
            isWelcomeDialogVisible = false;
          "
          text
        >
          {{ $t('welcome.checkbox.dont_show_again') }}
        </v-btn>

        <!-- Simple close -->
        <v-btn @click="close" text>{{ $t('welcome.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Features:
 * welcomeDoNotShowAgain: if true, a switch or an additional button is displayed to avoid displaying items again
 * - close and do not show again: not show up after reload, nor after login
 * - close and show up again after reload or after login
 * showEmptyWelcomeScreen: true to show aan empty welcome screen in case no item published
 *
 * States per item to be stored in local storage:
 * - readDate
 * - doNotShowAgain
 *
 * Check after lifecycle authentication state
 */
import configMixin from '@/mixins/configMixin';
import commonMixin from '@/mixins/common';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Welcome',
  mixins: [commonMixin, configMixin],
  data() {
    return {
      dontShowAgain: false,
    };
  },
  computed: {
    ...mapState('welcome', ['welcomeItems', 'welcomeItemToDisplay']),
    ...mapGetters('lifecycle', ['isReady']),
    welcomeItemImg() {
      if (this.welcomeItemToDisplay && this.welcomeItemToDisplay._file) {
        return this.welcomeItemToDisplay._file;
      }
      return null;
    },
    color() {
      return this.theme.appBar.other.color;
    },
    firstname() {
      const user = this.$store.state.profile.user;
      return user.firstName ? user.firstName : '';
    },
    lastname() {
      const user = this.$store.state.profile.user;
      return user.lastName ? user.lastName : '';
    },
    dayPhaseText() {
      const time = new Date().getHours();
      if (time >= 19) return this.$t('welcome.textEvening');
      if (time >= 8) return this.$t('welcome.textDay');
      return this.$t('welcome.textMorning');
    },
    dayPhase() {
      const time = new Date().getHours();
      if (time >= 19) return this.$t('welcome.dayPhase.evening');
      if (time >= 8) return this.$t('welcome.dayPhase.day');
      return this.$t('welcome.dayPhase.morning');
    },
    greeting() {
      let greetingText = '';
      if (this.welcomeItemToDisplay.greetings) {
        greetingText = this.welcomeItemToDisplay.greetings;
        greetingText = greetingText.replace('{dayphase}', this.dayPhase);
        greetingText = greetingText.replace('{firstname}', this.firstname);
        greetingText = greetingText.replace('{lastname}', this.lastname);
      } else {
        greetingText = '{dayphaseText} {firstname}!';
        greetingText = greetingText.replace('{dayphaseText}', this.dayPhaseText);
        greetingText = greetingText.replace('{firstname}', this.firstname);
      }

      return greetingText;
    },
    isWelcomeDoNotShowAgainEnabled() {
      return this.features.welcomeDoNotShowAgain === true;
    },
    isWelcomeDialogVisible: {
      get() {
        return this.features.showWelcomeScreen && this.welcomeItemToDisplay;
      },
      set(value) {
        if (!value && this.welcomeItemToDisplay) {
          this.$store.commit('welcome/markWelcomeItemAsRead', {
            welcomeItem: this.welcomeItemToDisplay,
            dontShowAgain: this.dontShowAgain,
          });

          this.dontShowAgain = false;
          console.debug('setShowWelcome=false');
          this.$store.commit('welcome/setShowWelcome', false);
        }
      },
    },
  },
  methods: {
    close() {
      this.dontShowAgain = false;
      this.isWelcomeDialogVisible = false;
    },
  },
  watch: {
    welcomeItemToDisplay(newValue, oldValue) {
      console.debug('welcomeItemToDisplay changed', newValue);
    },
  },
};
</script>
<style scoped>
.welcome-text {
  font-size: 1rem;
}
</style>
